import { PropsWithChildren, useEffect, useState } from "react";

interface InvoiceCancelWindowGateProps {
  createdAt: number | null | undefined;
  windowSeconds: number | null;
}

const getRemainingMs = (createdAt: number | null | undefined, windowSeconds: number | null) =>
  windowSeconds === null ? Infinity : (Number(createdAt) + windowSeconds) * 1000 - Date.now();

const InvoiceCancelWindowGate = ({
  createdAt,
  windowSeconds,
  children,
}: PropsWithChildren<InvoiceCancelWindowGateProps>) => {
  const [isOpen, setIsOpen] = useState(() => getRemainingMs(createdAt, windowSeconds) > 0);

  useEffect(() => {
    const remainingMs = getRemainingMs(createdAt, windowSeconds);
    setIsOpen(remainingMs > 0);
    if (!(remainingMs > 0) || !Number.isFinite(remainingMs)) return;
    const timer = setTimeout(() => setIsOpen(false), remainingMs);
    return () => clearTimeout(timer);
  }, [createdAt, windowSeconds]);

  return isOpen ? <>{children}</> : null;
};

export default InvoiceCancelWindowGate;
